export const RECAPTCHA_CREATE_NOTIFICATION = 'CreateNotification';
export const RECAPTCHA_VALIDATE_TOKEN = 'ValidateToken';
export const RECAPTCHA_SEND_EMAIL_NOTIFIES = 'SendEmailNotifies';
export const RECAPTCHA_ATTACHED_FILE = 'AttachedFile';
export const RECAPTCHA_GET_NOTIFICATIONS_ID_PASSWORD =
  'GetNotificationByIdAndPassword';
export const RECAPTCHA_SEND_CODE_EMAIL_NOTIFY = 'SendCodeNotifieyEmail';
export const RECAPTCHA_GET_TOKEN_EMAIL = 'GetTokenByEmailAndCode';
